import httpMethod from 'services/update2025/httpMethod';
import moment from "moment";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Toast } from "primereact/toast";
import React, { useContext, useRef } from "react";
import { useTranslation } from "react-i18next";
import { UserTransactionContext } from "./UserTransactionContext";
export const UserTransactionEditor = () => {
    const toast = useRef(null);
    const { t, i18n } = useTranslation(["user-transaction", "common"]);
    const tokenObj = httpMethod.getTokenStorage(); // { access_token, … }
    const accessToken = tokenObj?.access_token;;

    let headers = {
        Authorization: `Bearer ${accessToken}`,
        "Accept-Language": i18n.language,
    };

    const userTransactionContext = useContext(UserTransactionContext);
    const { userTransaction, resetUserTransaction, setUserTransaction, userTransactions, setUserTransactions, submitted, setSubmitted, userTransactionDialog, setUserTransactionDialog } = userTransactionContext;

    const requestStatuses = [
        { label: "Thành công", value: "SUCCESS" },
        { label: "Thất bại", value: "FAILURE" },
    ];

    const requestDateInput = (data) => {
        if (data) {
            return moment(data).format("DD/MM/YYYY HH:mm:ss");
        }
        return null;
    };

    const hideDialog = () => {
        setUserTransactionDialog(false);
    };

    return (
        <>
            <Toast ref={toast} />
            <Dialog visible={userTransactionDialog} style={{ width: "70%" }} header={t("user-transaction.titleDetail")?.toUpperCase()} modal className="p-fluid text-center" onHide={hideDialog}>
                <div className="formgrid">
                    <div className="grid text-left">
                        <div className="col-12">
                            <div className="grid">
                                {/* tên đăng nhập */}
                                <div className="field col-12 md:col-3">
                                    <label htmlFor="username">{t("user-transaction.username")}</label>
                                    <InputText name="username" id="username" value={userTransaction.username} autoFocus readOnly={true} />
                                </div>

                                {/* thời gian */}
                                <div className="field col-12 md:col-3">
                                    <label htmlFor="requestTime">{t("user-transaction.requestTime")}</label>
                                    <InputText name="requestTime" id="requestTime" value={requestDateInput(userTransaction.requestTime)} autoFocus readOnly={true} />
                                </div>

                                {/* địa chỉ IP */}
                                <div className="field col-12 md:col-3">
                                    <label htmlFor="userIpAddress">{t("user-transaction.userIpAddress")}</label>
                                    <InputText name="userIpAddress" id="userIpAddress" value={userTransaction.userIpAddress} autoFocus readOnly={true} />
                                </div>

                                {/* thiết bị */}
                                <div className="field col-12 md:col-3">
                                    <label htmlFor="deviceName">{t("user-transaction.deviceName")}</label>
                                    <InputText name="deviceName" id="deviceName" value={userTransaction.deviceName} autoFocus readOnly={true} />
                                </div>
                            </div>

                            <div className="grid">
                                {/* nội dung */}
                                <div className="field col-12 md:col-6">
                                    <label htmlFor="content">{t("user-transaction.request")}</label>
                                    <InputText name="content" id="content" value={userTransaction.content} autoFocus readOnly={true} />
                                </div>

                                {/* trạng thái */}
                                <div className="field col-12 md:col-3">
                                    <label htmlFor="requestStatus">{t("user-transaction.requestStatus")}</label>
                                    <InputText name="requestStatus" id="requestStatus" value={requestStatuses.find((e) => e.value === userTransaction?.requestStatus)?.label} autoFocus readOnly={true} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="grid">
                    <div className="col-12">
                        <Button
                            style={{
                                width: "max-content",
                            }}
                            label={t("close", { ns: "common" })}
                            icon="pi pi-times"
                            onClick={hideDialog}
                        />
                    </div>
                </div>
            </Dialog>
        </>
    );
};
